import React, { Component } from "react";
import StateTrustLandsService from "../services/StateTrustLands";
import BackButton from "../components/BackButton";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const sweetalert = withReactContent(Swal);

export default class StateTrustLands extends Component {
  constructor(props) {
    super(props);
    this.handleOnClickUploadCsv = this.handleOnClickUploadCsv.bind(this);
    this.uploadCsv = this.uploadCsv.bind(this);

    this.state = {
      isUploadingCsv: false,
      data: []
    };

    this.uploadCsvRef = React.createRef();
  }

  componentDidMount() {
    StateTrustLandsService.getData().then((resp) => {
      this.setState({ data: resp.data || [] });
    });
  }

  handleOnClickUploadCsv() {
    this.uploadCsvRef.current.click();
  }

  uploadCsv(e) {
    this.setState({ isUploadingCsv: true });

    const file = e.target.files[0];
    const formData = new FormData();
    formData.append("file", file);

    sweetalert.showLoading();

    StateTrustLandsService.readCsv(formData)
      .then((response) => {
        this.setState({ isUploadingCsv: false });

        if (response.error) {
          sweetalert.fire({
            icon: "error",
            title: "Error while uploading CSV",
            text: response.message,
            confirmButtonColor: "#0d6efd",
            willClose: () => { window.location.reload(); }
          });
          return;
        }

        if (response.success) {
          sweetalert.fire({
            icon: "success",
            title: "CSV uploaded successfully",
            html: `<p class="text-success sweetalert-text">Inserted: ${response.message.inserted}</p><p class="text-primary sweetalert-text">Updated: ${response.message.updated}</p><p class="text-danger sweetalert-text">Archived: ${response.message.deleted}</p>`,
            confirmButtonColor: "#0d6efd",
            willClose: () => { window.location.reload(); }
          });
        } else {
          sweetalert.fire({
            icon: "error",
            title: "Wrong CSV format",
            text: response.message,
            confirmButtonColor: "#0d6efd",
            willClose: () => { window.location.reload(); }
          });
        }
      })
      .catch(() => {
        this.setState({ isUploadingCsv: false });
        sweetalert.fire({
          icon: "error",
          title: "Error while uploading CSV",
          confirmButtonColor: "#0d6efd",
          willClose: () => { window.location.reload(); }
        });
      });

    return false;
  }

  render() {
    return (
      <div className="m-5">
        <BackButton />
        <h2>Fishing Regulations - State Trust Lands</h2>
        <p className="text-muted">
          STL Hunting & Fishing Access Program properties ({this.state.data.length} entries).
        </p>

        <div className="mb-3 d-flex align-items-end gap-3">
          <div>
            <input
              ref={this.uploadCsvRef}
              name="file"
              type="file"
              accept=".csv"
              hidden
              onChange={this.uploadCsv}
            />
            <button
              className="btn btn-success"
              onClick={this.handleOnClickUploadCsv}
              disabled={this.state.isUploadingCsv}
            >
              <span className="text-light">Upload CSV</span>
            </button>
          </div>
        </div>

        <table className="table table-hover table-bordered table-striped">
          <thead className="table-secondary">
            <tr>
              <th>external_id</th>
              <th>name</th>
              <th>county</th>
              <th>directions</th>
              <th>gmu_acres</th>
              <th>open_season</th>
              <th>hunting</th>
              <th>fishing</th>
              <th>restrictions</th>
            </tr>
          </thead>

          <tbody>
            {this.state.data.map((item) => (
              <tr key={item.id}>
                <td>{item.external_id}</td>
                <td>{item.name}</td>
                <td>{item.county}</td>
                <td style={{ whiteSpace: "pre-wrap" }}>{item.directions}</td>
                <td>{item.gmu_acres}</td>
                <td style={{ whiteSpace: "pre-wrap" }}>{item.open_season}</td>
                <td style={{ whiteSpace: "pre-wrap" }}>{item.hunting}</td>
                <td style={{ whiteSpace: "pre-wrap" }}>{item.fishing}</td>
                <td style={{ whiteSpace: "pre-wrap" }}>{item.restrictions}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}
